import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { headerCustomDisplaying, setCustomHeaderText } from "../store/mainSlice";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import swalDialog from "../helpers/swalErrorPopup";
import { isLoadChanger } from "../store/mainSlice";
import { PoweredBy } from "../shared/PoweredBy";
import { useTranslation } from "react-i18next";
import faqAPI from "../api/faqAPI";
import { isPartnerClalit } from "../store/partnerStore";

function Faq() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const isClalit = useSelector(isPartnerClalit);
  const [faqData, setFaqData] = useState([]);
  const mainUserParams = useSelector((state) => state.userSlice.mainUserData);

  useEffect(() => {
    dispatch(headerCustomDisplaying(true));
    dispatch(setCustomHeaderText(t("FAQ")));
    return () => {
      dispatch(headerCustomDisplaying(false));
      dispatch(setCustomHeaderText(""));
    };
  }, [t]);

  useEffect(() => {
    const fetch = async () => {
      try {
        dispatch(isLoadChanger(true));
        const param = await faqAPI.getFaqs({ token: mainUserParams.Token, id: mainUserParams.ID, phone: mainUserParams.Phone });
        setFaqData(param.data);
        dispatch(isLoadChanger(false));
      } catch (err) {
        swalDialog(err);
      }
    };
    if (mainUserParams && Object.keys(mainUserParams).length > 0) {
      fetch();
    }
  }, [mainUserParams]);

  return (
    <div className="fit-extend-selector-container h-100-percent">
      <div className="faq-main-container">
        <div className="faq-accordions" style={{ flexGrow: 1 }}>
          {faqData.map((el) => (
            <Accordion sx={{ boxShadow: "0", border: "0px", borderTop: "1px" }}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon sx={{ color: "var(--darkblue)" }} />}
                aria-controls="panel1-content"
                id="panel1-header"
                className="open-sans-hebrew"
                sx={{
                  direction: "rtl",
                  fontFamily: 'var(--font-family) !important',
                  fontSize: "16px",
                  color: "var(--darkblue)",
                  fontWeight: 700,
                }}
              >
                {el?.Question}
              </AccordionSummary>
              <AccordionDetails
                sx={{
                  direction: "rtl",
                  fontFamily: 'var(--font-family) !important',
                  padding: "8px 30px",
                  fontSize: "17px",
                  color: "#8D8F91",
                }}
              >
                {el?.Answer}
              </AccordionDetails>
            </Accordion>
          ))}
        </div>

        {isClalit && (
          <div style={{ position: "sticky", bottom: 0 }}>
            <PoweredBy />
          </div>
        )}
      </div>
    </div>
  );
}

export default Faq;
